<template>
  <div class="counselor-prompt">
    <h2>
      {{ promptHeader }}
    </h2>
    <div class="counselor-prompt__input-wrapper">
      <input
        v-model="prompt"
        type="text"
        minlength="2"
        :placeholder="promptPlaceholder"
        @keyup="submitOnEnter"
      />

      <!-- Start/Stop button -->
      <button
        v-show="speechIsActive && !isLoading"
        type="button"
        class="btn btn-cta counselor-prompt__speech-button"
        :class="{ 'counselor-prompt__speech-button--recording': isListening }"
      >
        <!-- Microphone icon -->
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M12 18.75a6 6 0 0 0 6-6v-1.5m-6 7.5a6 6 0 0 1-6-6v-1.5m6 7.5v3.75m-3.75 0h7.5M12 15.75a3 3 0 0 1-3-3V4.5a3 3 0 1 1 6 0v8.25a3 3 0 0 1-3 3Z"
          />
        </svg>
      </button>

      <!-- Submit/Loading button -->
      <button
        type="button"
        class="btn btn-cta counselor-prompt__submit-button"
        :disabled="!canSubmitPrompt"
        @click="submitPrompt"
      >
        <!-- Loading icon -->
        <svg
          v-show="isLoading || isLoadingLocal"
          class="counselor-prompt__speech-button--loading"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="2.2"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99"
          />
        </svg>

        <!-- Right arrow icon -->
        <svg
          v-show="!isLoading && !isLoadingLocal"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M13.5 4.5 21 12m0 0-7.5 7.5M21 12H3"
          />
        </svg>
      </button>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
//import recognition from 'Services/speech-recognition/speech-recognition';
import { useLanguageOptions } from 'Composables/useLanguageOptions';

export default {
  name: 'CounselorPrompt',

  setup() {
    const { getLanguageOptions } = useLanguageOptions();
    return { getLanguageOptions };
  },

  data() {
    const { siteId, adminMarket, promptHeader, promptPlaceholder } =
      this.$mountEl.dataset;

    return {
      siteId: JSON.parse(siteId) || null,
      adminMarket: JSON.parse(adminMarket) || null,
      prompt: '',
      previousPrompt: '',
      currentPrompt: '',
      results: [],
      isLoadingLocal: false,
      speechIsActive: false,
      isListening: false,
      debounceTimer: null,
      speechTimer: null,
      speechResults: [],
      promptHeader: promptHeader || 'Tell us how we may help',
      promptPlaceholder:
        promptPlaceholder || "Describe what you're looking for...",
    };
  },

  computed: {
    ...mapState('users', ['users', 'isLoading']),

    canSubmitPrompt() {
      const promptLength = this.prompt.trim().length;

      return (
        !this.isLoading &&
        !this.isLoadingLocal &&
        !this.isListening &&
        (promptLength === 0 || promptLength > 2)
      );
    },

    languageOptions() {
      return this.getLanguageOptions(this.users);
    },
  },

  methods: {
    ...mapActions('counselorGrid', ['clearFilters']),
    ...mapActions('users', ['clearPrompt']),

    async submitPrompt() {
      if (!this.prompt.trim().length) {
        this.clearPrompt();
        this.clearFilters();

        return;
      }

      if (this.canSubmitPrompt) {
        this.isLoadingLocal = true;

        await this.$store.dispatch('users/getUsersByPrompt', {
          prompt: this.prompt,
          siteId: this.siteId,
          adminMarket: this.adminMarket,
          languageOptions: this.languageOptions,
        });

        this.isLoadingLocal = false;
      }
    },

    async submitOnEnter(event) {
      if (event.key === 'Enter') {
        await this.submitPrompt();
      }
    },

    // startSpeechRecognition() {
    //   if (this.isListening) {
    //     recognition.stop();
    //
    //     this.isListening = false;
    //     this.prompt = `${this.previousPrompt} ${this.currentPrompt}`.trim();
    //     this.previousPrompt = this.prompt;
    //     this.currentPrompt = '';
    //
    //     return;
    //   }
    //
    //   this.isListening = true;
    //
    //   try {
    //     recognition.start();
    //
    //     this.previousPrompt = this.prompt;
    //   } catch (error) {
    //     // Safety check; the speech recognition might've already started.
    //     console.log(error);
    //   }
    //
    //   recognition.onresult = async (event) => {
    //     if (!this.isListening || !event || event.results.length === 0) {
    //       return;
    //     }
    //
    //     this.currentPrompt = Object
    //       .values(event.results)
    //       .map(result => result[0].transcript || '')
    //       .join('');
    //
    //     this.prompt = `${this.previousPrompt} ${this.currentPrompt}`.trim();
    //   };
    //
    //   recognition.onnomatch = (event) => console.log(event);
    //   recognition.onerror = (event) => console.log(event);
    // }
  },
};
</script>
